/**
 * Pure list reordering shared by top-level items and submenu children.
 * Sorts by `order`, swaps the item at `index` with its neighbour in the given
 * direction, then re-normalizes `order` to a dense 0-based sequence.
 * Out-of-range moves (first item up / last item down) are no-ops.
 */
export function moveInList<T extends { order?: number }>(
  list: T[],
  index: number,
  direction: "up" | "down"
): T[] {
  const sorted = [...list].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  const target = direction === "up" ? index - 1 : index + 1;

  if (index < 0 || index >= sorted.length || target < 0 || target >= sorted.length) {
    return sorted.map((item, idx) => ({ ...item, order: idx }));
  }

  [sorted[index], sorted[target]] = [sorted[target], sorted[index]];
  return sorted.map((item, idx) => ({ ...item, order: idx }));
}
